import lscache from "lscache";

export function AddToPersistentStorage(key: string, value: Object | string, time: number = 0) {
    if (time <= 0) {
        lscache.set(key, value);
    } else {
        lscache.set(key, value, time);
    }
}
